import numeral from 'numeral';

function formatMetric(input: number): string {
  return numeral(Math.round(input)).format('0,0');
}

export default formatMetric;
